import { render, staticRenderFns } from "./ActionItems.vue?vue&type=template&id=9e0ab532"
import script from "./ActionItems.vue?vue&type=script&lang=js"
export * from "./ActionItems.vue?vue&type=script&lang=js"
import style0 from "./ActionItems.vue?vue&type=style&index=0&id=9e0ab532&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
